namespace GeniuzPOS.QRreport {
    export enum SumWhsFg {
        all = 0,
        gwhs = 1
    }
    Serenity.Decorators.registerEnumType(SumWhsFg, 'GeniuzPOS.QRreport.SumWhsFg');
}
